import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { WxLabel } from "../..";
import { useMenuContext } from "../../../hooks/context/useMenuContext";
import { SLUG_CATEGORY } from "../../../styles/slugs";
import { appendCommitHash } from "../../../utils/appendHash";

type Props = {
  label: string;
  onClick?: () => void;
  active: boolean;
  hasSubMenu: boolean;
  slug?: string;
};

export const NavLink = ({
  label,
  onClick,
  active,
  hasSubMenu,
  slug,
}: Props) => {
  const { setOpen } = useMenuContext();

  return (
    <>
      {hasSubMenu && onClick ? (
        <Container onClick={onClick}>
          <WxLabel label={`${label}`} black active={active} hover={true} />
          <FontAwesomeIcon icon={faChevronRight} size={"sm"} />
        </Container>
      ) : (
        <Container>
          <Link
            to={appendCommitHash(`/${SLUG_CATEGORY}/${slug}`)}
            onClick={() => {
              setOpen(false);
            }}
          >
            <WxLabel label={label} black active={active} hover={true} />
          </Link>
        </Container>
      )}
    </>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &::not(:first-child) {
    padding-block: 0.125rem;
  }
  &:first-child {
    padding-bottom: 0.125rem;
  }
`;
